'use client';

import {X} from 'lucide-react';

interface PremiumReminderBannerProps {
  companyName: string;
  onClose: () => void;
  onShare: () => void;
}

// Dismissable inline banner shown to Premium users once per guide per session.
// Rendered between the editorial summary and the experiences list.
export function PremiumReminderBanner({companyName, onClose, onShare}: PremiumReminderBannerProps) {
  return (
    <div className='relative mb-6 rounded-xl border border-iq-grey-light bg-iq-grey-lighter px-5 py-4'>
      <button
        onClick={onClose}
        className='absolute top-3 right-3 text-iq-grey-medium hover:text-iq-grey-dark transition-colors'
        aria-label='Not now'>
        <X size={14} />
      </button>

      <p className='text-xs font-semibold text-iq-orange uppercase tracking-wide mb-1'>Quick ask</p>
      <h3 className='text-sm font-bold text-iq-black mb-1'>Interviewed at {companyName}?</h3>
      <p className='text-xs text-iq-grey-medium mb-3 leading-relaxed'>
        Share your experience to help other candidates prepare. Takes about 5 minutes and stays
        anonymous.
      </p>

      <div className='flex gap-2'>
        <button
          onClick={onShare}
          className='px-4 py-2 bg-iq-red text-white text-xs font-semibold rounded-lg hover:opacity-90 transition-opacity'>
          Share my experience
        </button>
        <button
          onClick={onClose}
          className='px-4 py-2 border border-iq-grey-light text-iq-grey-dark text-xs rounded-lg hover:bg-white transition-colors'>
          Not now
        </button>
      </div>
    </div>
  );
}
